// extracted by mini-css-extract-plugin
export default {"space":"Homepage_space__e8AEy"};